import { render, staticRenderFns } from "./classBadge.vue?vue&type=template&id=6dbb6316&scoped=true"
import script from "./classBadge.vue?vue&type=script&lang=js"
export * from "./classBadge.vue?vue&type=script&lang=js"
import style0 from "./classBadge.vue?vue&type=style&index=0&id=6dbb6316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb6316",
  null
  
)

export default component.exports